<template>
  <div>
    <!-- <main-layout> -->
      <!-- <v-tabs v-model="currentView" color="white" :slider-color="$vuetify.theme.primary">
        <v-tab ripple :key="'depausersregister'" :href="'#depausersregister'">{{
          $t('จำนวนผู้ลงทะเบียน')
        }}</v-tab>
        <v-tab
          ripple
          :key="'depausersapplyprojectapplicantsbystatus'"
          :href="'#depausersapplyprojectapplicantsbystatus'"
          >{{ $t('จำนวนผู้สมัครเข้าร่วมโครงการแยกตามสถานะ') }}</v-tab
        >
        <v-tab
          ripple
          :key="'depatopfiveusersapplyproject'"
          :href="'#depatopfiveusersapplyproject'"
          >{{ $t('TOP มาตราการ') }}</v-tab
        >

        <v-tab ripple :key="'customers'" :href="'#customers'">{{ $t('Customer') }}</v-tab>
      </v-tabs> -->

      <!-- <template v-if="currentView == 'customers'">
        <component :is="currentView"></component>
      </template> -->
      <template >
        <component :is="currentView"></component>
      </template>
    <!-- </main-layout> -->
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import numeral from 'numeral'
import TagReport from './TagReport.vue'
import StatCustomer from './StatCustomer.vue'
import StatSummary from './StatSummary.vue'
import ActiveUserGraph from './ActiveUserGraph.vue'
import Customers from './Customers.vue'
import SummaryIntent from './SummaryIntent.vue'
import BranchLocation from './BranchLocation.vue'
import Depausersregister from './Depausersregister.vue'

// import CentralHRCustomer from './CentralHRCustomer.vue'
import Depausersapplyprojectapplicantsbystatus from './Depausersapplyprojectapplicantsbystatus.vue'
import Depatopfiveusersapplyproject from './Depatopfiveusersapplyproject.vue'

export default {
  data: function() {
    return {
      showIntent: false,
      currentView: 'stat-summary'
    }
  },
  components: {
    StatSummary,
    ActiveUserGraph,
    SummaryIntent,
    Customers,
    TagReport,
    StatCustomer,
    BranchLocation,
    Depausersregister,
    Depausersapplyprojectapplicantsbystatus,
    Depatopfiveusersapplyproject
  },
  created: function() {
    let vm = this
    if (vm.$route.query.tab) {
      // switch (vm.$route.query.tab) {
      //   case 'statistic':
      //   case 'crm':
      //   case 'custom_analytic':
      //     vm.currentView = vm.$route.query.tab
      //     break
      //   default:
      //     vm.currentView = 'statistic'
      //     break
      // }
      vm.currentView = vm.$route.query.tab
    } else {
      vm.currentView = 'stat-summary'
    }
  },
  mounted: function() {},
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      currentLang: 'currentLang'
    }),
  },
  methods: {
    numberFormat: function(val) {
      return numeral(val).format('0,0')
    },
    updateRoute: function() {
      this.$router.push({
        name: 'dashboard',
        path: '/dashboard',
        query: {
          tab: this.currentView
        }
      })
      this.routeValue = JSON.stringify(this.$route.query)
    }
  },
  watch: {
    currentView: function() {
      this.updateRoute()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/view/dashboard/Dashboard.vue